<template>
  <div class="m-input" :class="{'s-label-empty': !label, 's-border': isBorder}">
    <div class="ex-field-wrapper">
      <label
        class="ex-field-title">{{ label }}
      </label>
      <div class="ex-field-value">
        <input :type="type"
          :value="value"
          :placeholder="placeholder"
          :maxlength="max"
          @input="updateValue($event.target.value)"
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VInput',
  props: {
    isBorder: {
      // 是否显示border
      default: true
    },
    type: {
      default: 'text'
    },
    max: {}, // 最大输出字数
    placeholder: [String], // 等待输入提示
    value: {},
    label: {
      // 名称
      default: ''
    }
  },
  methods: {
    updateValue (val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss">
.m-input {
  padding-left: 15px;
  background: #fff;
  &.s-border {
    border-bottom: solid 1px #ebebeb;
  }
  .ex-field-wrapper {
    width: 100%;
    line-height: 30px;
    padding: 8px 0px 8px 0;
    font-size: 1.4rem;
    
    &.s-label-empty {
      .ex-field-title {
        display: none;
      }
      input {
        width: 100%;
      }
    }
  }
  .ex-field-title {
    display: block;
    float: left;
    width: 30%;
    height: 30px;
  }
  .ex-field-value input {
    display: block;
    width: 65%;
    height: 30px;
    border: none;
    font-size: 1.4rem;
    padding-left: 5px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/base/input.vue